import { Visibility, VisibilityOff } from "@material-ui/icons";
import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useHistory } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const SignIn = () => {
  const history = useHistory();

  const emailRef = useRef();
  const passwordRef = useRef();
  const [error, setError] = useState({
    email: false,
    password: false,
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const { login } = useAuth();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  async function handleSubmit(e) {
    e.preventDefault();
    const email = emailRef.current?.value;
    const password = passwordRef.current?.value;
    if (!email && !password) { 
      setErrorMessage("Email and Password Cannot be Empty");
      setError((prev) => ({ ...prev, email: true, password: true }));
      return;
    } else if (!email) {
      setErrorMessage("UserName Cannot be Empty");
      setError((prev) => ({ ...prev, password: false }));
      return;
    } else if (!password) {
      setErrorMessage("Password Cannot be Empty");
      setError((prev) => ({ ...prev, email: false }));
      return;
    }

    try {
      setLoading(true);
      await login(emailRef.current.value, passwordRef.current.value);
      history.push("/dashboard");
    } catch {
      setErrorMessage("Some Error Occurred , Please Try Again Later");
      setError((prev) => ({ ...prev, email: false, password: false }));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ width: "100%", height: "100vh", display: "flex" }}>
      <div style={{ width: "60%", height: "100vh" }}>
        <img
          src="/combine_image.webp"
          alt="Dashboard Illustration"
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      <div
        style={{
          position: "relative",
          flex: 1,
          height: "100vh",
          backgroundColor: "#000",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "4.87rem",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "10rem",
            width: "20rem",
            height: "20rem",
            backgroundImage: 'url("/Background.png")',
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            transform: "rotate(-45deg)",
            opacity: 0.25,
            zIndex: 0,
            pointerEvents: "none",
          }}
        ></div>
        <p
          style={{
            margin: 0,
            color: "#FFF",
            fontFamily: "TASA Explorer",
            fontSize: "2.25rem",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "normal",
            letterSpacing: "0.0225rem",
            marginTop: "7.94rem",
          }}
        >
          Product Dashboard
        </p>
        <div
          style={{
            width: "23.5625rem",
            paddingTop: "2.75rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "30.4375rem",
            flexShrink: 0,
            fill: "rgba(22, 21, 21, 0.85)",
            strokeWidth: "",
            stroke: "rgba(255, 255, 255, 0.16)",
            boxShadow:
              "0px 3.606px 16.227px 0px rgba(131, 131, 131, 0.08) inset",
            backdropFilter: "blur(3.5px)",
            position: "relative",
            border: "1px solid rgba(255, 255, 255, 0.16)",
            borderRadius: "1.352rem",
          }}
        >
          <img
            src="/images/Coredata_Logo_black.svg"
            alt=""
            style={{
              width: "14.8125rem",
              height: "3.75rem",
              flexShrink: 0,
              objectFit: "cover",
            }}
          />
          <div
            style={{
              textAlign: "left",
              width: "19.9375rem",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
            }}
          >
            <p
              style={{
                margin: 0,
                color: "rgba(255, 255, 255, 0.90)",
                fontFamily: "Inter, sans-serif",
                fontSize: "1.01419rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal",
                marginTop: "2.75rem",
              }}
            >
              UserName
            </p>
            <input
              type="email"
              style={{
                display: "flex",
                color: "#FFF",
                padding: "1.35219rem",
                justifyContent: "space-between",
                alignItems: "center",
                flexShrink: 0,
                borderRadius: "0.45075rem",
                border: error["email"]
                  ? "1px solid #FF4C4C"
                  : "0.901px solid rgba(255, 255, 255, 0.14)",
                background: "#151515",
              }}
              onChange={() => {
                setErrorMessage("");
                setError((prev) => ({
                  ...prev,
                  email: false,
                  password: false,
                }));
              }}
              ref={emailRef}
            />
          </div>
          <div
            style={{
              textAlign: "left",
              width: "19.9375rem",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
            }}
          >
            <p
              style={{
                margin: 0,
                color: "rgba(255, 255, 255, 0.90)",
                fontFamily: "Inter, sans-serif",
                fontSize: "1.01419rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "normal",
                marginTop: "2.19rem",
              }}
            >
              Password
            </p>

            <div style={{ position: "relative", width: "100%" }}>
              <input
                ref={passwordRef}
                type={showPassword ? "text" : "password"}
                onChange={() => {
                  setErrorMessage("");
                  setError((prev) => ({
                    ...prev,
                    email: false,
                    password: false,
                  }));
                }}
                style={{
                  width: "100%",
                  padding: "1.35219rem",
                  paddingRight: "3rem", // extra space for the icon
                  color: "#FFF",
                  borderRadius: "0.45075rem",
                  border: error["password"]
                    ? "1px solid #FF4C4C"
                    : "0.901px solid rgba(255, 255, 255, 0.14)",
                  background: "#151515",
                  boxSizing: "border-box",
                }}
              />
              <span
                onClick={handleClickShowPassword}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "1rem",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#FFF",
                }}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </span>
            </div>
          </div>
          {errorMessage.length > 0 && (
            <div
              style={{
                color: "#FF4C4C",
                fontSize: "0.875rem",
                fontWeight: 500,
                marginTop: "0.5rem",
                width: "19.9375rem",
              }}
            >
              {errorMessage}
            </div>
          )}
          <button
            onClick={handleSubmit}
            type="submit"
            style={{
              width: "8.11331rem",
              height: "2.70444rem",
              flexShrink: 0,
              borderRadius: "0.45075rem",
              border: "1.352px solid rgba(227, 133, 0, 0.80)",
              background: "rgba(227, 133, 0, 0.07)",
              color: "#E38500",
              textAlign: "center",
              fontFamily: '"TASA Explorer", sans-serif',
              fontSize: "0.67613rem",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "normal",
              letterSpacing: "0.0135rem",
              cursor: "pointer",
              marginTop: "1.5rem",
            }}
          >
            {loading ? (
              <CircularProgress
                size="1rem"
                thickness={5}
                sx={{
                  color: "#E38500",
                  margin: "0 auto",
                }}
              />
            ) : (
              "Sign In"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
